import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CHANGELOG } from '../constants/version';
import { useTheme } from '../context/PermissionsContext/ThemeContext/ThemeContext';

interface ChangelogModalProps {
  open: boolean;
  onClose: () => void;
}

const ChangelogModal: React.FC<ChangelogModalProps> = ({ open, onClose }) => {
  const { theme } = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.background2,
          borderRadius: '16px',
          marginTop: '160px',
          height: '75%',
        },
      }}
    >
      <DialogTitle
        sx={{
          color: theme.text,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Changelog
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: theme.text }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {CHANGELOG.map((release) => (
          <Box key={release.version} sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ color: theme.text, mb: 1 }}>
              {release.version} - {release.date}
            </Typography>
            <Box component="ul" sx={{ mt: 0, color: theme.text }}>
              {release.changes.map((change, index) => (
                <Typography
                  component="li"
                  key={index}
                  sx={{ mb: 0.5, color: theme.text }}
                >
                  {change}
                </Typography>
              ))}
            </Box>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default ChangelogModal;
